/**
 * Hides/shows tabs after button click — scoped to nearest .at-product-accessories or .at-faq__inner
 */
class UseTabs extends HTMLElement {
  /**
   *
   */
  connectedCallback() {
    this.buttons = this.querySelectorAll('.at-tab__tile');

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        this.buttons.forEach((item) => item.classList.remove('active'));
        e.target.classList.add('active');

        const container = this.closest('.at-product-accessories') || this.closest('.at-faq__inner');
        if (!container) return;

        const contentTab = container.querySelector(`[data-tab-content='${e.target.dataset.tabId}']`);
        if (!contentTab) return;

        [...contentTab.parentElement.children].forEach((item) => item.classList.add('visually-hidden'));

        contentTab.classList.remove('visually-hidden');
      });
    });
  }
}

customElements.define('use-tabs', UseTabs);
